import styled from 'styled-components'

import { EmptyStateStyled } from '@ui/blocks/EmptyState/styles/EmptyStateStyled'

interface IFileListContainerStyledProps {}

export const FileListContainerStyled = styled.div<IFileListContainerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  ${EmptyStateStyled} {
    margin: 0;
  }
`
